import { Link } from "react-router-dom";
import Logo from "../assets/icons/logo-light.svg";
import Support from "../assets/icons/support.svg";
import { ReactComponent as Arrow } from "../assets/icons/arrow-down.svg";

import { useState } from "react";
const Footer = () => {
  const productLinks = [
    {
      to: "/money-transfer",
      open: false,
      text: "Send & Receive Money",
    },
    {
      to: "/virtual-card",
      open: false,
      text: "Virtual Dollar Card",
    },
    {
      to: "/virtual-wallet",
      open: false,
      text: "Virtual Wallet",
    },
    {
      to: "#",
      open: false,
      text: "Pay Bills",
    },

    {
      to: "#",
      open: false,
      text: "Buy Airtime",
    },

    // {
    //   to: "/business",
    //   open: false,
    //   text: "FX Kudi For Business",
    // },
  ];

  const resourcesLink = [
    {
      to: "https://fxkudiblog.com/",
      open: false,
      text: "Blog",
    },
    {
      to: "/about",
      open: false,
      text: "About Us",
    },
    {
      to: "/privacy",
      open: false,
      text: "Privacy Policy",
    },
    {
      to: "/terms",
      open: false,
      text: "Terms & Conditions",
    },
    {
      to: "/contact",
      open: false,
      text: "Support",
    },
    {
      to: "/faq",
      open: false,
      text: "FAQs",
    },
  ];

  const socialsLink = [
    {
      to: "https://facebook.com",
      open: false,
      text: "Facebook",
    },
    {
      to: "https://instagram.com",
      open: false,
      text: "Instagram",
    },
    {
      to: "https://twitter.com",
      open: false,
      text: "Twitter",
    },
    {
      to: "https://linkedin.com",
      open: false,
      text: "LinkedIn",
    },
  ];

  const locationLink = [
    {
      to: "https://goo.gl/maps/GsZHdWTnbCEiZEpj7",
      open: false,
      text: "28, Ezra Road, Greater Accra, Ghana",
    },
  ];

  const [product, setProduct] = useState(false);
  const [resources, setResources] = useState(false);
  const [social, setSocial] = useState(false);

  const toggleProduct = () => {
    setProduct(!product);
  };
  const toggleResources = () => {
    setResources(!resources);
  };
  const toggleSocial = () => {
    setSocial(!social);
  };

  return (
    <div className="bg-[#110D00]">
      <div className="container mx-0 lg:mx-auto flex flex-col gap-5 justify-center items-center py-5 md:py-10 px-4 md:px-10">
        <div className="flex flex-col gap-3 items-center border-b border-primary/20 w-full py-5">
          <Link to="/">
            <img src={Logo} alt="FXKudi" className="w-24" />
          </Link>
          <div className="flex items-center gap-2">
            <img src={Support} alt="" />
            <a
              href="mailto:support@fxkudi.com"
              className="text-primary font-medium text-sm md:text-base"
            >
              support@fxkudi.com
            </a>
          </div>
        </div>
        {/*  */}
        <div className="flex flex-col w-full justify-start items-start md:hidden py-10 gap-8">
          <div className="flex flex-col w-full">
            <div
              className="flex justify-between items-center"
              onClick={() => toggleProduct()}
            >
              <div className=" text-primary font-medium text-base">Product</div>
              <Arrow
                stroke="white"
                className={`${!product ? "" : "rotate-180"}`}
              />
            </div>
            <div
              className={`${
                product ? "block" : "hidden"
              } flex flex-col gap-4 mt-5`}
            >
              {productLinks.map((item) => (
                <div className="text-white font-normal text-sm" key={item.text}>
                  {item.text === "Kudi Hero" ? (
                    <a href={item.to} target="_blank" rel="noreferrer">
                      {item.text}{" "}
                    </a>
                  ) : (
                    <Link to={item.to}>{item.text}</Link>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col w-full">
            <div
              className="flex justify-between items-center"
              onClick={() => toggleResources()}
            >
              <div className=" text-primary font-medium text-base">
                Resources
              </div>
              <Arrow
                stroke="white"
                className={`${!resources ? "" : "rotate-180"}`}
              />
            </div>
            <div
              className={`${
                resources ? "block" : "hidden"
              } flex flex-col gap-4 mt-5`}
            >
              {resourcesLink.map((item) => (
                <div className="text-white font-normal text-sm" key={item.text}>
                  {item.text === "Blog" ? (
                    <a href={item.to} target="_blank" rel="noreferrer">
                      {item.text}{" "}
                    </a>
                  ) : (
                    <Link to={item.to}>{item.text}</Link>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col w-full">
            <div
              className="flex justify-between items-center"
              onClick={() => toggleSocial()}
            >
              <div className=" text-primary font-medium text-base">Socials</div>
              <Arrow
                stroke="white"
                className={`${!social ? "" : "rotate-180"}`}
              />
            </div>
            <div
              className={`${
                social ? "block" : "hidden"
              } flex flex-col gap-4 mt-5`}
            >
              {socialsLink.map((item) => (
                <div className="text-white font-normal text-sm" key={item.text}>
                  <a href={item.to} target="_blank" rel="noopener noreferrer">
                    {item.text}
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col w-full">
            <div className=" text-primary font-medium text-base">
              Where we're at
            </div>
            <div className={` flex flex-col gap-4 mt-5`}>
              {locationLink.map((item) => (
                <div className="text-white font-normal text-sm" key={item.text}>
                  <a href={item.to} target="_blank" rel="noreferrer">
                    {item.text}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/*  */}
        <div className="hidden md:flex justify-between items-start w-full gap-3 py-5">
          <div className="flex flex-col justify-center items-start">
            <div className="font-medium text-primary">Products</div>
            <div className="flex flex-col gap-3 mt-5">
              {productLinks.map((item) => (
                <div className="text-white text-sm" key={item.text}>
                  {item.text === "Kudi Hero" ? (
                    <a href={item.to} target="_blank" rel="noreferrer">
                      {item.text}{" "}
                    </a>
                  ) : (
                    <Link to={item.to}>{item.text}</Link>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col justify-center items-start">
            <div className="font-medium text-primary">Resources</div>
            <div className="flex flex-col gap-3 mt-5">
              {resourcesLink.map((item) => (
                <div className="text-white text-sm" key={item.text}>
                  {item.text === "Blog" ? (
                    <a href={item.to} target="_blank" rel="noreferrer">
                      {item.text}{" "}
                    </a>
                  ) : (
                    <Link to={item.to}>{item.text}</Link>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col justify-center items-start">
            <div className="font-medium text-primary">Socials</div>
            <div className="flex flex-col gap-3 mt-5">
              {socialsLink.map((item) => (
                <div className="text-white text-sm" key={item.text}>
                  <a href={item.to} target="_blank" rel="noopener noreferrer">
                    {item.text}
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col justify-center items-start">
            <div className="font-medium text-primary">Where we're at</div>
            <div className="flex flex-col gap-3 mt-5">
              {locationLink.map((item) => (
                <div className="text-white text-sm" key={item.text}>
                  <a href={item.to} target="_blank" rel="noopener noreferrer">
                    {item.text}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/*  */}
        <div className="flex flex-col gap-3 items-center border-t border-primary/20 w-full pt-10 text-white">
          <h3 className="text-sm">
            Copyright &copy; 2023 FXKudi Inc. All Rights Reserved
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Footer;
